'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.measurementsRemove = exports.measurementsSet = undefined;

var _measurementsConstants = require('./measurementsConstants');

var measurementsSet = exports.measurementsSet = function measurementsSet(_ref) {
  var id = _ref.id,
      measurements = _ref.measurements;
  return { type: _measurementsConstants.MEASUREMENT_SET, id: id, measurements: measurements };
}; // Constants
var measurementsRemove = exports.measurementsRemove = function measurementsRemove(_ref2) {
  var id = _ref2.id;
  return { type: _measurementsConstants.MEASUREMENT_REMOVE, id: id };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/measurementsActions.js
// module id = 1909
// module chunks = 0